<ng-container *ngIf="!isLoggedIn && !isWarmState && isReady">
  <div id="login-signup-container" class="login-signup-container flex">
    <div
      class="container-signup items-center tablet:flex mr-[16px]"
      [ngClass]="{ 'max-[767px]:hidden': shopHeader }"
      id="mach-core-login-signup-container"
    >
      <a
        id="signup-trigger"
        [attr.href]="signupLoginContent?.signupLoginContent?.signupLink"
        class="container-signup__button text-label-xs-semibold !text-inverse whitespace-nowrap"
        data-acdl-action="header:sign up"
        data-acdl-name="sign up"
        data-acdl-page-section="header:sign up"
        (click)="analyticsEventEmit($event)"
      >
        {{ signupLoginContent?.signupLoginContent?.signupLabel }}
      </a>
      <div
        id="signup-tooltip"
        class="tooltip"
        [ngClass]="{ hidden: !signupCondition }"
      >
        <div class="flex items-center gap-8">
          <span class="text-label-xs-medium">
            {{ signupLoginContent?.toolTipContent?.tooltipSignUpContent }}
          </span>
          <button
            class="tooltip-close-btn"
            (click)="closeSignupTooltip()"
            id="mach-core-login-signup-tooltip-close"
            aria-label="Close tooltip"
          >
            <span class="tooltip-close-icon"></span>
          </button>
        </div>
      </div>
    </div>
    <div class="button-container" id="mach-core-login-button-container">
      <button
        id="login-trigger"
        class="button button-primary button-sm whitespace-nowrap !h-[28px]"
        tabindex="0"
        role="button"
        [attr.aria-label]="
          (signupLoginContent?.signupLoginContent?.loginLabel || 'Log In') +
          ', opens in new popup'
        "
        data-acdl-action="header:log in"
        data-acdl-name="log in"
        data-acdl-page-section="header:log in"
        (click)="toggleModal(); analyticsEventEmit($event)"
      >
        {{ signupLoginContent?.signupLoginContent?.loginLabel }}
      </button>
      <div
        id="login-tooltip"
        class="tooltip w-[260px] tablet:w-[360px] mobile:-ml-[80px] tablet:-ml-[60px]"
        *ngIf="loginCondition"
      >
        <div class="flex items-center gap-8">
          <span
            class="text-label-xs-medium flex-1 break-words whitespace-normal tablet:text-justify"
          >
            {{ signupLoginContent?.toolTipContent?.tooltipLoginContent }}
          </span>
          <button
            class="tooltip-close-btn flex-shrink-0"
            (click)="closeLoginTooltip()"
            id="mach-core-login-tooltip-close"
          >
            <span class="tooltip-close-icon"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="(isLoggedIn || isWarmState) && isReady">
  <button
    id="mach-core-login-flyout-details"
    class="flyout-details flex items-center gap-[6px] hover:cursor-pointer"
    data-acdl-action="header skymiles flyout"
    data-acdl-name="skymiles profile flyout"
    data-acdl-page-section="header:skymiles flyout"
    (click)="open($event); $event.stopPropagation()"
    (keydown)="openLoggedInFlyout($event)"
    tabindex="0"
  >
    <div
      class="flyout-name-container flex flex-col"
      id="mach-core-login-flyout-name-container"
    >
      <span
        class="flyout-name text-right text-inverse text-caption-medium max-w-[65px] overflow-hidden text-ellipsis whitespace-nowrap"
      >
        {{
          loggedInDetails.preferredName
            ? loggedInDetails.preferredName
            : loggedInDetails.firstName
        }}
      </span>
      <span
        [ngClass]="{
          'text-loyalty-text-tier-01': loggedInDetails.membershipLevel === 'FF',
          'text-loyalty-text-tier-02':
            loggedInDetails.membershipLevel === 'SM' ||
            loggedInDetails.membershipLevel === 'FO',
          'text-loyalty-text-tier-03': loggedInDetails.membershipLevel === 'GM',
          'text-loyalty-text-tier-04': loggedInDetails.membershipLevel === 'PM',
          'text-loyalty-text-tier-05': loggedInDetails.membershipLevel === 'DM'
        }"
        class="text-caption-semibold text-right whitespace-nowrap"
      >
        {{ loggedInDetails?.smBalance | number }}
        {{ signupLoginContent?.milesLabel?.labelName }}
      </span>
    </div>
    <div>
      <svg
        [ngClass]="{
          'rotate-180': flyoutToggle
        }"
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.99854 6L0.498535 2H7.49854L3.99854 6Z"
          fill="white"
        />
      </svg>
    </div>
  </button>
  <div
    id="account-recovery-tooltip"
    class="tooltip w-[260px] tablet:w-[360px] mobile:-ml-[80px] tablet:-ml-[60px]"
    *ngIf="accountRecoveryCondition"
    (click)="$event.stopPropagation()"
  >
    <div class="flex gap-8 items-start justify-between">
      <div class="flex-1">
        <h3 class="text-label-md-medium mb-8 tablet:text-justify">
          {{
            signupLoginContent?.toolTipContent?.tooltipAccountRecoveryContent
              ?.header
          }}
        </h3>
        <p class="text-label-sm-medium mb-16 tablet:text-justify">
          {{
            signupLoginContent?.toolTipContent?.tooltipAccountRecoveryContent
              ?.label
          }}
        </p>
        <a
          class="link text-label-sm-medium"
          [href]="
            signupLoginContent?.toolTipContent?.tooltipAccountRecoveryContent
              ?.link
          "
          id="mach-core-login-account-recovery-link"
          (click)="onAccountRecoveryLinkClick()"
        >
          {{
            signupLoginContent?.toolTipContent?.tooltipAccountRecoveryContent
              ?.linkLabel
          }}
        </a>
      </div>
      <button
        class="tooltip-close-btn flex-shrink-0"
        (click)="closeAccountRecoveryTooltip($event)"
        id="mach-core-login-account-recovery-tooltip-close"
      >
        <span class="tooltip-close-icon"></span>
      </button>
    </div>
  </div>
</ng-container>
